import React, { useState } from "react";
import styled from "styled-components";
import { FiMonitor, FiSmartphone } from "react-icons/fi";
import { tokens, surface, hairline } from "../../../styles/designTokens";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: none;
  min-width: 0;

  .preview-toggle {
    display: inline-flex;
    align-self: center;
    align-items: center;
    gap: 4px;
    padding: 3px;
    background: ${({ theme }) => surface(theme, 1)};
    border: 1px solid ${({ theme }) => hairline(theme)};
    border-radius: ${tokens.radiusMd};
    flex-shrink: 0;

    button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      background: transparent;
      border: none;
      border-radius: ${tokens.radiusSm};
      color: ${({ theme }) => theme.text};
      opacity: 0.55;
      font-size: 0.72em;
      font-weight: 500;
      cursor: pointer;
      transition: all ${tokens.durBase} ${tokens.easeOut};

      svg { font-size: 0.95em; }

      &.active {
        opacity: 1;
        background: ${tokens.brandSoft};
        color: ${tokens.brand};
      }
    }
  }

  .preview-frame-container {
    height: 320px;
    display: flex;
    justify-content: center;
    background: ${({ theme }) => surface(theme, 0)};
    border: 1px solid ${({ theme }) => hairline(theme)};
    border-radius: ${tokens.radiusLg};
    padding: 14px;
    overflow: hidden;
    position: relative;

    .frame-shell {
      width: 100%;
      height: 100%;
      max-width: ${({ $mode }) => ($mode === "mobile" ? "375px" : "100%")};
      background: #fff;
      border-radius: ${tokens.radiusMd};
      overflow: hidden;
      box-shadow: ${tokens.shadowMd};
      transition: max-width ${tokens.durBase} ${tokens.easeOut};

      iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
      }
    }
  }
`;

/**
 * Renderiza o HTML de um template de email dentro de um <iframe> isolado
 * (sandbox), simulando visualização em Desktop/Mobile.
 *
 * Segurança: sandbox="allow-same-origin" apenas — nunca adicionar
 * "allow-scripts", pois o HTML enviado pelo usuário não deve poder
 * executar JS no contexto do app.
 */
export default function TemplatePreviewFrame({ htmlContent, height = 320 }) {
  const [mode, setMode] = useState("desktop");

  return (
    <Wrapper $mode={mode}>
      <div className="preview-toggle">
        <button
          className={mode === "desktop" ? "active" : ""}
          onClick={() => setMode("desktop")}
          type="button"
        >
          <FiMonitor /> Desktop
        </button>
        <button
          className={mode === "mobile" ? "active" : ""}
          onClick={() => setMode("mobile")}
          type="button"
        >
          <FiSmartphone /> Mobile
        </button>
      </div>

      <div className="preview-frame-container" style={{ height }}>
        <div className="frame-shell">
          <iframe
            srcDoc={htmlContent || "<p style='font-family:sans-serif;color:#94a3b8;padding:24px;'>Nenhum template carregado.</p>"}
            sandbox="allow-same-origin"
            title="Preview do template de email"
          />
        </div>
      </div>
    </Wrapper>
  );
}
